import NavBarAdmin from "../../components/Admin/Layout/NavBarAdmin";
import { useEffect } from "react";
import CustomerAdminTable from "../../components/Admin/Table/CustomerAdminTable";
import SearchBar from "../../components/Admin/Services/SearchBar";
import { useServiceStore } from "../../stores/admin/service";
import { usePartnerStore } from "../../stores/admin/users";
import { useParams } from "react-router-dom";
import { getUsersCustomersByIdPartner } from "../../services/Api/partnerService";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import { ToastContainer } from "react-toastify";
import { showToastError } from "../../services/Toasts/toasts";

const AdminCustomer = () => {
  // Store
  const { update, searchTerm } = useServiceStore();
  const { usersCustomer, setUsersCustomer } = usePartnerStore();
  const { idPartner } = useParams();

  // Function to display users partner filtered or not
  useEffect(() => {
    if (searchTerm !== "") {
      const filteredRequests = usersCustomer?.filter(
        (item: any) =>
          item?.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.eMail.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setUsersCustomer(filteredRequests);
    } else {
      getUsersCustomersByIdPartner(Number(idPartner))
        .then((data) => setUsersCustomer(data))
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, [searchTerm, update]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start">
        <NavBarAdmin />
        <ToastContainer position="top-center" />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Liste des clients <span className="text-yellow-trio">({usersCustomer?.length || 0})</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez les clients et leurs informations
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Barre de recherche avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 mb-3 border border-gray-100">
              <div className="w-80">
                <SearchBar />
              </div>
          </div>

          {/* Table des clients avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden ">
            <CustomerAdminTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminCustomer;
